import React from 'react';

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-5xl',
    full: 'max-w-7xl',
  };

  return (
    <div className='fixed inset-0 z-50 overflow-y-auto'>
      {/* Backdrop */}
      <div
        className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className='flex items-center justify-center min-h-screen p-4'>
        <div
          className={`relative bg-white rounded-lg shadow-xl w-full ${sizeClasses[size]} max-h-[90vh] flex flex-col`}
        >
          {/* Header */}
          <div className='flex items-center justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0'>
            <h3 className='text-lg font-semibold text-gray-900'>{title}</h3>
            <button
              onClick={onClose}
              className='text-gray-400 hover:text-gray-600 focus:outline-none transition-colors'
            >
              <svg
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M6 18L18 6M6 6l12 12'
                />
              </svg>
            </button>
          </div>

          {/* Body - Scrollable */}
          <div className='px-6 py-4 overflow-y-auto flex-1'>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;